import React from 'react';
import styles from './actSlotAdd.module.css';

import InlineTimePicker from './InlineTimePicker';
import { timeToMinutes } from './timeUtils';

const CustomSlotForm = ({
    customStart,
    customEnd,
    customTotal,

    setCustomStart,
    setCustomEnd,
    setCustomTotal,

    onAdd,
    onCancel,

    editing = false
}) => {
    const handleStartTimeChange = (value) => {
        setCustomStart(value);

        if (!customEnd) {
            return;
        }

        const start = timeToMinutes(value);
        const end = timeToMinutes(customEnd);

        if (start !== null && end !== null && end <= start) {
            setCustomEnd('');
        }
    };

    return (
        <div className={styles.customSlotSection}>
            {/* -------------------------------------------------
                TITLE
            ------------------------------------------------- */}

            <label className={styles.sectionTitle}>{editing ? 'Edit slot' : 'Add custom slot'}</label>

            {/* -------------------------------------------------
                START / END TIME
            ------------------------------------------------- */}

            <div className={styles.customTimeRow}>
                {/* START TIME */}

                <div className={styles.customTimeField}>
                    <label>Start Time</label>

                    <InlineTimePicker value={customStart} onChange={handleStartTimeChange} />
                </div>

                {/* ARROW */}

                <div className={styles.timeArrow}>→</div>

                {/* END TIME */}

                <div className={styles.customTimeField}>
                    <label>End Time</label>

                    <InlineTimePicker
                        value={customEnd}
                        onChange={setCustomEnd}
                        minTime={customStart}
                        disabled={!customStart}
                    />
                </div>
            </div>

            {/* -------------------------------------------------
                TOTAL SLOTS
            ------------------------------------------------- */}

            <div className={styles.customTotalField}>
                <label>Total Slots</label>

                <input
                    type='number'
                    min={1}
                    value={customTotal}
                    placeholder='Enter total slots'
                    className={styles.totalSlotsInput}
                    onChange={(e) => {
                        const value = e.target.value;

                        setCustomTotal(value === '' ? '' : Number(value));
                    }}
                />
            </div>

            {/* -------------------------------------------------
                ACTIONS
            ------------------------------------------------- */}

            <div className={styles.customSlotActions}>
                <button type='button' className='dateAddBtn blueBtn' onClick={onAdd}>
                    {editing ? '✓ Save Slot' : '+ Add Slot'}
                </button>

                <button type='button' className={styles.cancelCustomSlot} onClick={onCancel}>
                    Cancel
                </button>
            </div>
        </div>
    );
};

export default CustomSlotForm;
